import { render } from "./DemoChart.vue?vue&type=template&id=5d364fca&scoped=true"
import script from "./DemoChart.vue?vue&type=script&lang=js"
export * from "./DemoChart.vue?vue&type=script&lang=js"

import "./DemoChart.vue?vue&type=style&index=0&id=5d364fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d364fca"]])

export default __exports__